import { render } from "./FiscalizacaoPessoaFisica.vue?vue&type=template&id=17405bfa"
import script from "./FiscalizacaoPessoaFisica.vue?vue&type=script&lang=js"
export * from "./FiscalizacaoPessoaFisica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__